module.exports = __webpack_public_path__ + "img/hic-infectious-diseases-female.12e56827.png";